import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["highlightColor", "size", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/* eslint-disable @typescript-eslint/no-unused-vars */

var IconCrossCircle = function IconCrossCircle(_ref) {
  _ref.highlightColor;
    var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({
    width: size,
    height: size
  }, newProps), {}, {
    className: classNames('sol-icon', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "icon-cross-circle"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM15.1436 16.5578L11.9557 13.3699L8.76777 16.5578C8.5725 16.7531 8.25592 16.7531 8.06066 16.5578L7.35355 15.8507C7.15829 15.6554 7.15829 15.3389 7.35355 15.1436L10.5415 11.9557L7.35355 8.76777C7.15829 8.5725 7.15829 8.25592 7.35355 8.06066L8.06066 7.35355C8.25592 7.15829 8.5725 7.15829 8.76777 7.35355L11.9557 10.5415L15.1436 7.35355C15.3389 7.15829 15.6554 7.15829 15.8507 7.35355L16.5578 8.06066C16.7531 8.25592 16.7531 8.5725 16.5578 8.76777L13.3699 11.9557L16.5578 15.1436C16.7531 15.3389 16.7531 15.6554 16.5578 15.8507L15.8507 16.5578C15.6554 16.7531 15.3389 16.7531 15.1436 16.5578Z",
    fill: "currentColor"
  })));
};

export { IconCrossCircle };
